import React from 'react';
import qs from 'qs';
import {search,clearResults,setLimitExceeded} from '../actions/search';
import {connect} from 'react-redux';
import {change, getFormValues, SubmissionError, submit} from 'redux-form';
import {withRouter} from 'react-router';
import SearchView from '../components/Search';
import {
    getIsSearchFetching,
    getSearchResultCount,
    getSearchResults,
    getSearchLimitExceeded,
} from '../reducers/root';

/**
 * Search Container
 */
class Search extends React.Component {

    componentDidMount = () => {
        const {dispatch, initialValues} = this.props;
        if (initialValues.searchTerm || initialValues.location) {
            window.setTimeout(() => dispatch(submit("SearchForm")), 100);
        }
    };

    render = () => (
        <SearchView {...this.props} />
    );
}

const mapStateToProps = state => ({
    count: getSearchResultCount(state),
    fetching: getIsSearchFetching(state),
    results: getSearchResults(state),
    limitExceeded: getSearchLimitExceeded(state),
    formValues: getFormValues("SearchForm")(state),
    initialValues: {
        ...qs.parse(window.location.search.substr(1)),
        page: 1,
    },
});

const mapDispatchToProps = dispatch => {
    const performSubmit = values => {
        const errors = {};
        if (!values.searchTerm && !values.location) {
            errors._error = 'Bitte geben sie einen Suchbegriff und/oder einen Ort an.';
        } else {
            if (values.searchTerm && values.searchTerm.length < 3)
                errors.searchTerm = 'Bitte geben Sie mindestens drei Zeichen ein';
            if (values.location && values.location.length < 3)
                errors.location = 'Bitte geben Sie mindestens drei Zeichen ein';
        }

        if (Object.keys(errors).length)
            throw new SubmissionError(errors);

        const url = window.location.pathname + '?' + qs.stringify({...values, page: undefined}, {arrayFormat: 'bracket', encode: false, skipNulls: true});
        window.history.replaceState({}, '', url);
        dispatch(clearResults());
        return dispatch(search.action({urlParams: values})).catch(response => {
            if (response.error && response.error.limitExceeded) {
                dispatch(setLimitExceeded(response.error.time));
            }
        })
    };
    const performSubmitWithPage = (values, page) => {
        page = page || 1;
        dispatch(change("SearchForm", "page", page));
        return performSubmit({...values, page});
    };
    const performCleanSubmit = values => {
        return performSubmitWithPage(values, 1);
    };
    return {
        dispatch,
        onSubmit: performCleanSubmit,
        performCleanSubmit,
        performSubmitWithPage,
    };
};

Search = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Search));

export default Search;


// WEBPACK FOOTER //
// ./src/containers/Search.js